import { OSM } from "ol/source";
import { Tile as TileLayer, Vector as VectorLayer } from "ol/layer";
import gcj02Mecator from "./gcj02Mecator";
import XYZ from "ol/source/XYZ";

// 全部底图数据
export const allLayers = [];
var localObj = window.location;
var protocol = "http://"
let apiUrl = localObj.protocol + "//" + localObj.host
if(process.env.NODE_ENV=='developement'){
  apiUrl = "http://192.168.20.208:18030"
}

// 开放道路底图
export const OSMLayer = new TileLayer({
  title: "underlayLayer", // 底图名称
  source: new OSM(), // 数据源
  zIndex: 0, // 图层层级0
});

// 谷歌地图
export const GoogleLayer = new TileLayer({
  title: "underlayLayer",
  source: new XYZ({
    projection: gcj02Mecator,
    url: protocol+"www.google.cn/maps/vt/pb=!1m4!1m3!1i{z}!2i{x}!3i{y}!2m3!1e0!2sm!3i345013117!3m8!2szh-CN!3scn!5e1105!12m4!1e68!2m2!1sset!2sRoadmap!4e0",
  }),
  zIndex: 0,
});

// 高德在线
export const GDMapOnline = new TileLayer({
  title: "underlayLayer",
  source: new XYZ({
    projection: gcj02Mecator,
    url: protocol+"wprd0{1-4}.is.autonavi.com/appmaptile?lang=zh_cn&size=1&style=7&x={x}&y={y}&z={z}",
  }),
  zIndex: 0,
});

// 修改天地图URL配置，确保在iOS上正常工作
// 天地图道路
export const TMStreet = new TileLayer({
  title: "underlayLayer",
  source: new XYZ({
    url: apiUrl + "/t4/tianditu?T=vec_w&tk=207a7b31f8588ba2a8df864d967b6c15&x={x}&y={y}&l={z}",
    // 添加tileLoadFunction自定义处理
    tileLoadFunction: function(imageTile, src) {
      const image = imageTile.getImage();
      if (image && src) {
        image.crossOrigin = 'anonymous';
        image.src = src;
      }
    }
  }),
  zIndex: 0,
});

// 天地图卫星
export const TMSatellite = new TileLayer({
  title: "underlayLayer",
  source: new XYZ({
    url: apiUrl+"/t4/tianditu?T=img_w&tk=207a7b31f8588ba2a8df864d967b6c15&x={x}&y={y}&l={z}",
  }),
  zIndex: 0,
});

// 天地图标注
export const TMTitle = new TileLayer({
  title: "underlayLayerForTMTitle",
  source: new XYZ({
    url: apiUrl+"/t3/tianditu?T=cva_w&tk=207a7b31f8588ba2a8df864d967b6c15&x={x}&y={y}&l={z}",
  }),
  zIndex: 0,
});

allLayers.push(
  OSMLayer,
  GoogleLayer,
  GDMapOnline,
  TMStreet,
  TMSatellite,
  TMTitle
); // 将底图数据添加到全部底图数据